import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { IDynamicElement } from '../_shared/models/dynamic/dynamic-element.model';
import { ITextWithIntro, TextWithIntroTitleVariant } from '../_shared/models/text-with-intro.model';
import { GridComponent } from '../grid/grid.component';
import { HeadingCategory, HeadingComponent } from '../heading/heading.component';
import { TextHtmlComponent } from '../text-html/text-html.component';

@Component({
    selector: 'sirius-text-with-intro',
    templateUrl: './text-with-intro.component.html',
    styleUrls: ['./text-with-intro.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [GridComponent, HeadingComponent, TextHtmlComponent],
    host: {
        '[class.has-large-title]': "titleVariant === 'large'",
    },
})
export class TextWithIntroComponent implements OnInit, IDynamicElement {
    @Input() config?: ITextWithIntro;
    @Input() eyebrow = '';
    @Input() title = '';
    @Input() titleVariant: TextWithIntroTitleVariant = 'default';
    @Input() subTitleHtml?: string;
    @Input() textHtml = '';

    protected get titleCategory(): HeadingCategory {
        return this.titleVariant === 'large' ? 'display' : 'title';
    }

    protected get titleSize(): 's' | 'm' {
        return this.titleVariant === 'large' ? 's' : 'm';
    }

    ngOnInit(): void {
        if (this.config) {
            this.eyebrow = this.config.eyebrow ?? '';
            this.title = this.config.title;
            this.titleVariant = this.config.titleVariant ?? 'default';
            this.subTitleHtml = this.config.subTitleHtml;
            this.textHtml = this.config.textHtml;
        }
    }
}
